import { AiFillRuntimeInput } from 'api/ai-fill/types';
import { FileAttachment } from 'api/attachments';
import { User } from 'api/models';
import { Color } from 'components/colors';

interface StatusUser extends User {
  identityType: 'USER' | 'NATIVE';
}

export enum StatusUpdatePrivacy {
  Shared = 'SHARED',
  Private = 'PRIVATE',
}

export enum StatusUpdateState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum TaskStatusType {
  Completed = 'completed',
  Blocked = 'blocked',
  Overdue = 'became_overdue',
  Upcoming = 'upcoming',
  InProgress = 'in_progress',
}

type Email = { emailId: string };
interface UpdatableStatusUpdate {
  collaborators: User[];
  ccUsers: Email[];
  toUsers: User[];
  attachments: FileAttachment[];
  state: StatusUpdateState;
  status?: {
    statusId: number;
    statusValue: string;
  } | null;
  statusUpdateTitle: string;
  private: boolean;
}

export type ResourceObject = {
  fieldName: string;
  fieldType: string;
  fieldDataType: string;
  customField?: boolean;
  fieldValue: any;
  optionsAvailable?: boolean;
  fieldLabel: string;
  metaFieldValue?: any;
};

export type PublishedDataType = {
  resourceSectionId: number;
  resourceSectionType: string;
  resourceType?: string;
  resourceNames?: string[];
  resourceIds?: number[];
  resourceObjects: ResourceObject[];
};

export interface StatusUpdate extends UpdatableStatusUpdate {
  createdAt: number;
  updatedAt: number;
  createdBy: StatusUser;
  project: { projectId: number };
  document: {
    documentId: number;
  };
  publishedAt: number;
  publishedBy?: StatusUser;
  statusUpdateId: number;
  seenByUser: boolean;
  publishedData?: PublishedDataType[];
}

export interface StatusUpdateUpdatePayload
  extends Partial<UpdatableStatusUpdate> {
  publishedContent?: string;
  aiFillRuntimeInput: AiFillRuntimeInput;
}

export const UserStatusUpdateStatuses = {
  onTrack: {
    type: 'success',
    key: 'onTrack',
    value: 1,
    group: 1,
    color: 'green' as Color,
    label: 'On Track',
  },
  aheadOfTime: {
    type: 'inProgress',
    key: 'aheadOfTime',
    value: 2,
    group: 1,
    color: 'teal' as Color,
    label: 'Ahead of time',
  },
  runningLate: {
    type: 'warn',
    key: 'runningLate',
    value: 3,
    group: 1,
    color: 'yellow' as Color,
    label: 'Running Late',
  },
  atRisk: {
    type: 'error',
    key: 'atRisk',
    value: 4,
    group: 1,
    color: 'red' as Color,
    label: 'At Risk',
  },
  none: {
    type: 'default',
    key: 'none',
    value: 5,
    group: 1,
    color: 'gray' as Color,
    label: 'None',
  },
};

export const StatusUpdateStatuses = {
  ...UserStatusUpdateStatuses,
  autoPublished: {
    type: 'special',
    key: 'autoPublished',
    value: 6,
    group: 1,
    color: 'purple' as Color,
    label: 'Auto published',
  },
};
